import type { NavigateFunction } from 'react-router-dom';

/** Go to the previous history entry when possible; otherwise navigate to fallback. */
export const navigateBack = (navigate: NavigateFunction, fallbackPath: string): void => {
  if (typeof window !== 'undefined' && window.history.length > 1) {
    navigate(-1);
    return;
  }
  navigate(fallbackPath, { replace: true });
};
